import React from "react";
import { Root } from "./style";

import { useSiteData } from "utils";
import RawHTML from "components/Common/RawHTML";

import coinmarketcap from "assets/Common/JoinTheCommunities/coinmarketcap.svg";
import discord from "assets/Common/JoinTheCommunities/discord.svg";
import facebook from "assets/Common/JoinTheCommunities/facebook.svg";
import instagram from "assets/Common/JoinTheCommunities/instagram.svg";
import reddit from "assets/Common/JoinTheCommunities/reddit.svg";
import telegram from "assets/Common/JoinTheCommunities/telegram.svg";
import tiktok from "assets/Common/JoinTheCommunities/tiktok.svg";
import twitter from "assets/Common/JoinTheCommunities/twitter.svg";
import youtube from "assets/Common/JoinTheCommunities/youtube.svg";

import vars from "variables";

const JoinTheCommunities = () => {
  const {
    banners: { joinTheCommunities },
  } = useSiteData().resources;

  return (
    <Root className="join-the-communities body-width">
      <div className="bg smaller" />
      <div className="bg smallest" />
      <div className="bg">
        <RawHTML html={joinTheCommunities} />
        <ul>
          <li>
            <a href={vars.links.telegram} target="_blank" rel="noreferrer">
              <img src={telegram} />
            </a>
          </li>
          <li>
            <a href={vars.links.discord} target="_blank" rel="noreferrer">
              <img src={discord} />
            </a>
          </li>
          <li>
            <a href={vars.links.twitter} target="_blank" rel="noreferrer">
              <img src={twitter} />
            </a>
          </li>
          <li>
            <a href={vars.links.reddit} target="_blank" rel="noreferrer">
              <img src={reddit} />
            </a>
          </li>
          <li>
            <a href={vars.links.facebook} target="_blank" rel="noreferrer">
              <img src={facebook} />
            </a>
          </li>
          <li>
            <a href={vars.links.instagram} target="_blank" rel="noreferrer">
              <img src={instagram} />
            </a>
          </li>
          <li>
            <a
              href="https://coinmarketcap.com/community/profile/HODLofficial/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={coinmarketcap} />
            </a>
          </li>
          <li>
            <a href={vars.links.youtube} target="_blank" rel="noreferrer">
              <img src={youtube} />
            </a>
          </li>
          <li>
            <a href={vars.links.tiktok} target="_blank" rel="noreferrer">
              <img src={tiktok} />
            </a>
          </li>
        </ul>
      </div>
    </Root>
  );
};

export default JoinTheCommunities;
